import React from "react";
import styled from "styled-components";

interface SignInButtonProps {
  onClick: () => void;
}

const Button = styled.div`
  height: 50px;
  width: 240px;
  background-color: #4285f4;
  border: none;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;

  &:hover {
    box-shadow: 0 0 3px 3px rgb(66 133 244 / 30%);
  }
  &:active {
    background-color: #3367d6;
  }
`;

const ButtonInner = styled.div`
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  > .sign-in {
    font-size: 16px;
    line-height: 48px;
    font-family: Roboto, arial, sans-serif;
    font-weight: 500;
    letter-spacing: 0.21px;
    flex-grow: 1;
    text-align: center;
  }
`;

const GoogleIcon = styled.div`
  padding: 15px;
  background-color: #fff;
  border-radius: 1px;
  > img {
    display: flex;
    width: 18px;
    height: 18px;
  }
`;

export function GoogleSignInButton({ onClick }: SignInButtonProps) {
  return (
    <Button onClick={onClick}>
      <ButtonInner>
        <GoogleIcon>
          <img src="/img/btn_google_light_normal_ios.svg" alt="Google Icon" />
        </GoogleIcon>
        <span className="sign-in">Sign in with Google</span>
      </ButtonInner>
    </Button>
  );
}
